import getConversionDomain from '../helpers/getConversionDomain'
import getConversionDomainValidation from '../helpers/getConversionDomainValidation'
import getShowUrlTagsStep from '../helpers/getShowUrlTagsStep'
import { formatAdUrlTagsToBE } from './formatAdUrlTagsToBE'
import { formatAdCreativeToBE } from './formatAdCreativeToBE'
import { formatDegreesOfFreedomSpec } from './formatDegreesOfFreedomSpec'

import { getAppDomainName } from '../../../../../../features/helpers/getAppDomainName'

import { LEAD_GENERATION } from '../../../../../../constants/campaigns'
import {
  CAROUSEL_ITEMS,
  FB_SPONSOR_PAGE_ID,
  FORMAT_OPTION,
  INCLUDE_PARTNERSHIP_PAGE,
  INSTAGRAM_ACCOUNT_SPONSOR_ID,
  STORIES_ITEMS
} from '../../../fields'
import { MEDIA_TYPE } from '../../../../../ReusableFormFields/AdFileUpload/fields'
import { IS_QUARANTINE } from '../../../../../reusableFields'

export const transformValuesToBE = ({
  values,
  selectedAdAccountId,
  adSetId,
  campaignId,
  validateOnly,
  validatedDomains,
  partnershipUtmMedium,
  isInternalAdCreation,
  rightsHolderId,
  selectedApplicationId,
  selectedPixelPassedFromOutside,
  allowSendPixel,
  lineItem
}) => {
  const { name, status, url_tags_option, url_tags, pixel_choice } = values
  const { [FORMAT_OPTION]: formatOption, [CAROUSEL_ITEMS]: carouselItems } = values

  // if pixel is passed from outside, we use it in payload and don't show the step in ad form
  const pixel = selectedPixelPassedFromOutside || pixel_choice

  const conversionDomain = getConversionDomain(values)
  const appName = getAppDomainName()

  const { wasDomainValidated, isDomainValid } = getConversionDomainValidation(conversionDomain, validatedDomains)

  const showUrlTagsStep = getShowUrlTagsStep(values)
  const tags = showUrlTagsStep ? formatAdUrlTagsToBE(url_tags_option, url_tags, partnershipUtmMedium, appName) : null

  const includePartnershipPage = values[INCLUDE_PARTNERSHIP_PAGE]
  const sponsorFacebookPageId = values[FB_SPONSOR_PAGE_ID]
  const sponsorFacebookPageLinkedInstagramAccountId = values[INSTAGRAM_ACCOUNT_SPONSOR_ID]

  // tracking_specs should be removed for lead generation ads
  const sendTrackingSpecs = lineItem.objective !== LEAD_GENERATION

  return {
    name,
    status,
    account: selectedAdAccountId,
    adset_id: adSetId,
    campaign_id: campaignId,
    engagement_audience: false,
    creative: {
      degrees_of_freedom_spec: formatDegreesOfFreedomSpec({
        formatOption,
        carouselItems,
        storiesItems: values[STORIES_ITEMS],
        mediaType: values[MEDIA_TYPE]
      }),
      // partnership pages
      ...(includePartnershipPage &&
        sponsorFacebookPageId && {
          facebook_branded_content: {
            [FB_SPONSOR_PAGE_ID]: sponsorFacebookPageId
          }
        }),
      ...(includePartnershipPage &&
        sponsorFacebookPageLinkedInstagramAccountId && {
          instagram_branded_content: {
            [INSTAGRAM_ACCOUNT_SPONSOR_ID]: sponsorFacebookPageLinkedInstagramAccountId
          }
        }),
      ...formatAdCreativeToBE({ values, tags, selectedAdAccountId, lineItem })
    },
    // pass quarantine only during real ad Create(not validate request),
    // isInternalAdCreation is default, also allow to pass it manually if user has ability to select it(values[IS_QUARANTINE])
    ...((isInternalAdCreation || values[IS_QUARANTINE]) &&
      !validateOnly && {
        quarantine: true,
        ...(rightsHolderId && { account_id: rightsHolderId, rights_holder_account_id: rightsHolderId })
      }),
    ...(allowSendPixel &&
      pixel && {
        ...(sendTrackingSpecs && {
          tracking_specs: [
            {
              fb_pixel: [pixel],
              action_type: ['offsite_conversion']
            }
          ]
        }),
        // facebook doesn't have an endpoint to tell us what the valid domains are.
        // Therefore we need to have a workaround to check whether the domain is valid.
        // If domain is not valid, we don't include it into payload
        ...(((wasDomainValidated && isDomainValid) || validateOnly) && { conversion_domain: conversionDomain })
      }),
    ...(selectedApplicationId &&
      sendTrackingSpecs && {
        tracking_specs: [
          {
            action_type: ['mobile_app_install'],
            application: [selectedApplicationId]
          }
        ]
      }),
    // this field is used to test whether the ad will give an error, without creation the ad
    ...(validateOnly && { execution_options: ['validate_only'] })
  }
}
